import { useUser } from "../hooks/authHooks";
import StandardButton from "@jnctn/design-system/Button/StandardButton.component";
import FlexLayoutItem, {
  layouts,
} from "@jnctn/design-system/Flexbox/FlexLayoutItem.component";
import Text from "@jnctn/design-system/Text/Text.component";
import { Reset } from "@jnctn/error-handling/ErrorBoundary.component";
import FullPageLayout from "@jnctn/design-system/Layout/FullPageLayout.component";
import { useAutoSigninOnExpired } from "@jnctn/bridge/hooks/useAutoSigninOnExpired";
import { useAuthContext } from "../../contexts/AuthContextProvider";

export default function ErrorUnauthorized({ reset }: { reset: Reset }) {
  const { onSignIn, removeUser } = useAuthContext();
  const user = useUser();
  useAutoSigninOnExpired();

  return (
    <FullPageLayout align="center" direction="vertical" type="black">
      <FlexLayoutItem
        grow={1}
        layout={layouts.verticalCenterAll}
        className="space-y-3"
      >
        {user && user.expired ? (
          <Text color="white" size="header1" textAlign="center">
            Login has expired.
          </Text>
        ) : (
          <>
            <Text color="white" size="header1" textAlign="center">
              Please log in for access.
            </Text>
            <Text color="white" size="body1" textAlign="center">
              This resource is only available to authenticated members.
            </Text>
          </>
        )}
        {!user || !user.expired ? (
          <>
            <StandardButton
              label={user ? "Relogin" : "Login"}
              className="w-60 mt-10"
              onClick={() => {
                removeUser();
                onSignIn();
              }}
            />
            <StandardButton
              label="Refresh"
              onClick={reset}
              className="w-60"
              type="secondary"
            />
          </>
        ) : (
          <StandardButton
            label="Refresh"
            onClick={() => {
              window.location.href = "/";
            }}
            className="w-60"
            type="secondary"
          />
        )}
      </FlexLayoutItem>
    </FullPageLayout>
  );
}
